import { Component, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { BehavioralService } from "../claimprocess/service/behavioral.service";
import { ISetUpPasswordResetRequest } from "../claimprocess/model/setUpPassword.model";
import { SecurityQuestionsService } from "../claimprocess/service/securityQuestions.service";
import { IQuestionRequest } from "../claimprocess/model/question.model";

@Component({
  templateUrl: "./template/forgotPassword.component.html",
  styles: [
    `
      em {
        float: right;
        color: #e05c65;
        padding-left: 10px;
      }
          .error-message {
            display: flex;
            width: 1208px;
            padding-right: 0px;
            flex-direction: row;
            align-items: flex-start;
            gap: 10px;
            border-radius: 5px;
            border: 1px solid var(--ngp-error-light-500, #bd2b41);
            background: var(--ngp-primary-0, #fff);
    
            .error-message-left {
              display: flex;
    
              width: 5%;
              height: 72px;
              display: flex;
              padding: 12px;
              justify-content: center;
              align-items: center;
              gap: 10px;
              align-self: stretch;
              border-radius: 5px 0px 0px 5px;
              background: var(--ngp-error-light-500, #bd2b41);
            }
    
            .error-message-middle {
              display: flex;
              width: 90%;
              height: 72px;
              display: flex;
              padding: 12px;
              justify-content: center;
              align-items: center;
              gap: 10px;
              align-self: stretch;
            }
    
            .error-message-right {
              display: flex;
              width: 5%;
              height: 72px;
              display: flex;
              padding: 12px;
              justify-content: center;
              align-items: center;
              gap: 10px;
              align-self: stretch;
            }
          }
      
    





    `,
  ],
})
export class ForgotPasswordComponent implements OnInit {
  public userName: string;
  mouseoverLogin;
  forgotPasswordForm: UntypedFormGroup;
  displayError: boolean;
  errorResponse: any;

  constructor(
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private behavioralService: BehavioralService,
    private securityQuestionsService: SecurityQuestionsService

  ) {}
  ngOnInit(): void {
    this.forgotPasswordForm = this.formBuilder.group({
      username: ["", [Validators.required]],
    });
  }

  get f() {
    return this.forgotPasswordForm.controls;
  }

  forgotPassword(formValues) {
    this.userName = formValues.username;

   


    let dataIn: IQuestionRequest = {
      "workflow_arg": this.userName,
      "user_type": "employee"
    }

    this.securityQuestionsService
    .getUserSecurityQuestions(dataIn)
    .subscribe((questions) => {

      if(questions.status === 500) {

        

      this.errorResponse = questions.body;
      this.displayError = true;
      } else {



      let data: ISetUpPasswordResetRequest = {
        user_name: this.userName,
        user_type: "employee"
      };

      this.behavioralService.sendQAListResetPassword(data)


      this.router.navigate([
        "identityiq/external/forgotPassword/answerQuestions",
      ]);
    }
    }, (b) =>  {

      this.errorResponse = b;
      this.displayError = true;
      


    }
    
    
    )




  }

  closeDisplayError() {
    this.displayError = false;
  }
}
